import useFetch from '@hooks/useFetch';

export const getBatchDemoClassesKey = (batchUID) =>
  `v2/batch/${batchUID}/demo-class/`;

export const getCourseDemoClassesKey = (courseUID) =>
  `v1/uplus/${courseUID}/demo-class/`;

const useDemoClasses = (key) => {
  const { data: { data: demoClasses } = {}, ...rest } = useFetch(key);

  return {
    key,
    demoClasses,
    ...rest,
    isError: rest.isError || !!demoClasses?.errorCode
  };
};

export default useDemoClasses;
